import { format, subMonths } from 'date-fns'
import type { TotalUsageOverTimeResponse } from 'teacher-ui-client/utils/student-events/fetchers/total-usage-over-time'

const thisMonth = format(new Date(), 'yyyy-MM')
const lastMonth = format(subMonths(new Date(), 1), 'yyyy-MM')

export const fastPhonicsTotalUsageOverTime: TotalUsageOverTimeResponse = {
  total_usage_over_time_summary: [
    { category: 'books', event_count: 2, student_count: 1 },
    { category: 'lessons', event_count: 3, student_count: 2 },
    { category: 'quizzes', event_count: 3, student_count: 2 },
    { category: 'sounds', event_count: 2, student_count: 1 },
    { category: 'words', event_count: 2, student_count: 2 },
  ],
  total_usage_over_time_by_month: [
    {
      category: 'books',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
    {
      category: 'lessons',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
    {
      category: 'quizzes',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
    {
      category: 'sounds',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
    {
      category: 'words',
      months: [
        { month: lastMonth, count: 1 },
        { month: thisMonth, count: 2 },
      ],
    },
  ],
}
